import { FC } from 'react'
import { Box, Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { H2 } from '@/components/atoms/typography'
import useTranslation from 'next-translate/useTranslation'
import { Routes } from '@/core/routes'
import Link from '@/components/atoms/link'
import MenuLogoutPart from '../atoms/menuLogoutPart'
import { useUser } from '@/providers/userProvider'

const LoginDropdownRedesign: FC = ({ ...rest }) => {
  const { t } = useTranslation('common')
  const { user, isLoggedIn } = useUser()
  const isSigned = isLoggedIn && !!user?.id
  const title = isSigned ? `${user.firstname} ${user.lastname}` : null

  const listItemsSigned = [
    {
      id: 0,
      title: t('Account.SubPageNavigation.accountTitle'),
      href: user?.mainAddress?.id
        ? `${Routes.accountInfo}/${user.mainAddress.id}`
        : Routes.accountAddAddress
    },
    {
      id: 1,
      title: t('Account.SubPageNavigation.ordersTitle'),
      href: Routes.orderHistory
    },
    {
      id: 2,
      title: 'Newsletter',
      href: Routes.accountNewsletter
    }
  ]

  const listItemsNotSigned = [
    {
      id: 0,
      title: t('Tower.Toolbar.Buttons.registration'),
      href: Routes.registration
    },
    {
      id: 1,
      title: t('Tower.Toolbar.Buttons.login'),
      href: Routes.login
    }
  ]

  return (
    <StyledDropDown data-testid="loginDropDown" {...rest}>
      <StyledContent>
        {isSigned ? (
          <>
            <Title>{title}</Title>
            <StyledUl>
              {listItemsSigned.map((item) => (
                <Link key={item.id} href={item.href}>
                  <StyledLi>{item.title}</StyledLi>
                </Link>
              ))}
              <StyledLi>
                <MenuLogoutPart />
              </StyledLi>
            </StyledUl>
          </>
        ) : (
          <>
            <Title>{t('Tower.MyProfile.title')}</Title>
            <StyledUl>
              {listItemsNotSigned.map((item) => (
                <Link key={item.id} href={item.href}>
                  <StyledLi>{item.title}</StyledLi>
                </Link>
              ))}
            </StyledUl>
          </>
        )}
      </StyledContent>
    </StyledDropDown>
  )
}

export default LoginDropdownRedesign

const StyledDropDown = styled(Box)`
  left: auto;
  min-width: 260px;
  padding-top: 6px;
  position: absolute;
  right: -6px;
  top: 100%;
  z-index: 10;
  &:after {
    background-color: #fff;
    border-left: 1px solid #d1d1d1;
    border-top: 1px solid #d1d1d1;
    content: '';
    height: 15px;
    pointer-events: none;
    position: absolute;
    right: 24px;
    top: 0px;
    -webkit-transform: translateX(-50%) rotate(45deg);
    transform: translateX(-50%) rotate(45deg);
    width: 15px;
    z-index: 20;
  }
`

const StyledContent = styled(Flex)`
  flex-direction: column;
  background: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  -webkit-box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 20px;
`

const Title = styled(H2)`
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
  margin-top: 0;
  margin-bottom: 0.8em;
`

const StyledUl = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

const StyledLi = styled.li`
  color: ${(props) => props.theme.colors.towerColorSecondary};
  font-weight: 500;
  line-height: 2.125;
  font-size: 15px;
  position: relative;
  width: fit-content;
  &:before {
    background-color: ${(props) => props.theme.colors.towerColorPrimary};
    border-radius: 2px;
    bottom: 5px;
    content: '';
    height: 2px;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
  }
  &:hover {
    color: ${(props) => props.theme.colors.towerColorBlack};
    transition: color 0.3s;
    &::before {
      transition: opacity 0.3s;
      opacity: 1;
    }
  }
`
